<template>
  <div class="filter-wrapper">
    <app-button
      ref="button"
      data-qa="change-reservation-status-button"
      :aria-expanded="show ? 'true' : 'false'"
      @click.stop="toggleFilter"
    >
      <icon icon="filter" />
      {{ i18n.t('/StockDashboard/ChangeReservationStatus') }}
    </app-button>
    <div ref="filter">
      <slide-in-animation v-if="show">
        <div class="filter">
          <form action="">
            <div class="fields">
              <app-fieldset title="Reservation status" class="fieldset">
                <form-checkbox
                  v-for="(status, index) in reservationStatusNew"
                  :id="'reservation-' + index"
                  :key="status.value"
                  :title="i18n.t(status.labelKey)"
                >
                  <input
                    :id="'reservation-' + index"
                    v-model="selectedReservationStatus"
                    :data-qa="'reservation-status-' + status.value"
                    type="checkbox"
                    :value="status.value"
                    name="reservation-status"
                    @change="updateFilter"
                  />
                </form-checkbox>
              </app-fieldset>
            </div>
          </form>
        </div>
      </slide-in-animation>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import SlideInAnimation from '@/components/generic/animations/SlideIn.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { ref } from 'vue'
import ReservationStatusNew from '@/helpers/enums/reservationStatusNew'

export default {
  components: {
    FormCheckbox,
    AppFieldset,
    SlideInAnimation,
    AppButton,
    Icon,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['onUpdateReservationStatus'],
  setup() {
    const filter = ref(null)

    return {
      filter,
    }
  },
  data() {
    return {
      show: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      selectedReservationStatus: [],
    }
  },
  computed: {
    reservationStatusNew() {
      return ReservationStatusNew
    },
  },
  mounted() {
    this.selectedReservationStatus = this.modelValue
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    toggleFilter() {
      if (this.show) {
        this.hideFilter()
      } else {
        this.showFilter()
      }
    },
    showFilter() {
      this.show = true
      this.$nextTick(() => {
        this.addEventListeners()
      })
    },
    hideFilter() {
      this.show = false
      this.removeEventListeners()
    },
    addEventListeners() {
      document.addEventListener('keydown', this.closeByEscapeKey)
      document.addEventListener('click', this.closeByClickingOutsideFilter)
    },
    removeEventListeners() {
      document.removeEventListener('keydown', this.closeByEscapeKey)
      document.removeEventListener('click', this.closeByClickingOutsideFilter)
    },
    closeByEscapeKey(event) {
      if (event.keyCode !== 27) return
      this.hideFilter()
    },
    closeByClickingOutsideFilter(event) {
      if (this.filter.contains(event.target)) return
      this.hideFilter()
    },
    updateFilter() {
      this.$emit('onUpdateReservationStatus', this.selectedReservationStatus)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  position: relative;
}

.filter {
  position: absolute;
  background: $white;
  top: 100%;
  left: 0;
  border: 1px solid $gray;
  padding: 0.25em;
  margin-top: 0.5em;
  z-index: 9;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 1em;
    top: -0.5em;
    border-left: 0.5em solid transparent;
    border-right: 0.5em solid transparent;
    border-bottom: 0.5em solid;
  }

  &::before {
    border-bottom-color: $gray;
  }

  &::after {
    margin-top: 1px;
    border-bottom-color: $white;
  }
}

.fieldset :deep() {
  .radio-button {
    margin-top: 0;
  }

  .fields {
    grid-gap: 0.25em;
    margin-bottom: 0;
  }
}

.icon {
  @include icon();

  fill: currentColor;
}
</style>
